import React from 'react';

import { useI18n } from 'i18n';
import { ITepOfficer } from 'types/tep';
import { IInfoTableCell } from 'types/info-table';
import { Actions } from 'components/organisms/tep/tep-management/modals/officers-modals/cells/actions';
import { Remarks } from 'components/organisms/tep/tep-management/modals/officers-modals/cells/remarks';
import { ContactNumber } from 'components/organisms/tep/tep-management/modals/officers-modals/cells/contact-number';

export const useOfficersColumns = () => {
  const { fc } = useI18n();

  const getContactOnCell = (cell: IInfoTableCell<ITepOfficer, string>) => <ContactNumber officer={cell.row} />;

  const getRemarksCell = (cell: IInfoTableCell<ITepOfficer, string>) => <Remarks officer={cell.row} />;

  const getActionsCell = (cell: IInfoTableCell<ITepOfficer, string>) => <Actions officer={cell.row} />;

  return [
    { header: fc('Contact Number'), accessorKey: 'phone', cell: getContactOnCell, width: 200, minWidth: 200 },
    { header: fc('remarks'), accessorKey: 'remarks', cell: getRemarksCell, minWidth: 120 },
    { accessorKey: 'actions', header: fc('actions'), cell: getActionsCell, width: 100, minWidth: 100 },
  ];
};
